// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3XHq5","footer":"styles_footer__3rleL","passCodeTooltip":"styles_passCodeTooltip__2bx4U"};